export default {
  label: {
    description: 'Comparado con ',
  },
};
